import type { TFunction } from 'i18next';
import { RitualType } from '../client/generated/graphql';

export type RitualConfig = {
    title: string;
    description?: string;
    label?: string;
    icon: string;
    iconBg: string;
    iconColor?: string;
    cardBg: string;
    borderColor?: string;
    chevronColor?: string;
    dotColor?: string;
    completedBg?: string;
    bannerBg?: string;
    labelBg?: string;
    buttonBgEnabled?: string;
    buttonText?: string;
};

const THEME_ACCENT = 'var(--tg-theme-button-color)';
const THEME_ACCENT_TEXT = 'var(--tg-theme-button-text-color)';

const sharedRitualColors = {
    iconBg: THEME_ACCENT,
    iconColor: THEME_ACCENT_TEXT,
    cardBg: THEME_ACCENT,
    borderColor: THEME_ACCENT,
    chevronColor: THEME_ACCENT,
    dotColor: THEME_ACCENT,
    completedBg: THEME_ACCENT,
    bannerBg: THEME_ACCENT,
    labelBg: THEME_ACCENT,
    buttonBgEnabled: THEME_ACCENT,
    buttonText: THEME_ACCENT_TEXT,
};

export const getRitualConfig = (t: TFunction): Record<RitualType, RitualConfig> => ({
    [RitualType.Morning]: {
        title: t('ritual.morningTitle'),
        description: t('ritual.description'),
        label: t('journal.morning'),
        icon: 'light_mode',
        ...sharedRitualColors,
    },
    [RitualType.Evening]: {
        title: t('ritual.eveningTitle'),
        description: t('ritual.description'),
        label: t('journal.evening'),
        icon: 'dark_mode',
        ...sharedRitualColors,
    },
});
